module.exports = {
      id: "video-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svg-sprite-0ef3134280a050ca46b4726dfe0fed42.svg#video",
      toString: function () {
        return this.url;
      }
    }